import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DocSearch from '../DocSearchLanding';
import styled from 'styled-components';
import withConfiguration from '../ProductCard/withConfiguration';
import ProductCard from '../ProductCard';
import backgroundImage from './hero-background-image.svg';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 265px;
    position: absolute;
    left: 0px;
    top: 74px;
    background-image: url(${backgroundImage});
    background-size: cover;
`;

const Spacer = styled.div`
    padding: 100px;
`;

const SmallSpacer = styled.div`
    padding: 6px;
    margin-top: 25px;
`;

const SearchContainer = styled.div`
    padding: 1em 2em;
    font-size: 14px;
    @media only screen and (max-width: 600px) {
        /* For mobile phones: */
         {
            font-size: 12px;
        }
    }
`;

const ProductContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`;

const ProductWrapper = styled.div`
    flex: none;
    width: 410px;
    margin: 10px !important;
    padding: 10px;
    @media only screen and (max-width: 599px) {
        /* For mobile phones: */
         {
            width: 100%;
            padding: 0;
        }
    }
`;

const styles = {
    searchTitleText: {
        color: 'white',
        fontWeight: 500,
        textAlign: 'center',
        fontSize: '2.5em',
        letterSpacing: '0.25px',
        fontFamily: 'Roboto',
    },
    searchTitleDescription: {
        color: 'white',
        textAlign: 'center',
        fontSize: '1.5em',
        fontWeight: 400,
        linkColor: 'white',
        maxWidth: 801,
        marginTop: 20,
    },
    frontNote: {
        color: 'black',
        textAlign: 'center',
        fontSize: '1em',
        letterSpacing: '0.25px',
        fontFamily: 'Roboto',
    },
};

const MSProduct = withConfiguration(ProductCard, 'media-shuttle');
const JetProduct = withConfiguration(ProductCard, 'jet');
const MAProduct = withConfiguration(ProductCard, 'manager');
const FlightProduct = withConfiguration(ProductCard, 'flight');

const LandingPageLayout = ({ classes }) => {
    return (
        <div>
            <Container>
                <SearchContainer>
                    <div className={classes.searchTitleText}>Signiant Help Center</div>
                    <div className={classes.searchTitleDescription}>
                        Signiant’s Help Center provides documentation on all our products.
                        <br />
                        If you can’t find what you’re looking for, contact our world-class{' '}
                        <a
                            style={{ color: '#FFF', textDecoration: 'underline' }}
                            href="https://support.signiant.com/hc/en-us/articles/360020531833-Contact-Support"
                            target="_blank"
                            rel="noreferrer"
                        >
                            support team
                        </a>
                        .
                    </div>
                    <br />
                    <DocSearch />
                </SearchContainer>
            </Container>
            <Spacer />

            <SmallSpacer />
            <SmallSpacer />

            <ProductContainer>
                <ProductWrapper>
                    <MSProduct />
                </ProductWrapper>
                <ProductWrapper>
                    <JetProduct />
                </ProductWrapper>
            </ProductContainer>
            <ProductContainer>
                <ProductWrapper>
                    <MAProduct />
                </ProductWrapper>
                <ProductWrapper>
                    <FlightProduct />
                </ProductWrapper>
            </ProductContainer>
        </div>
    );
};

LandingPageLayout.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LandingPageLayout);
